import {Component, EventEmitter, HostListener, inject, Input, OnChanges, Output} from '@angular/core';
import {FieldStateService} from '../../core/field-state.service';
import {SectionsContainer} from '../../core/definitions/sections-container';
import {UiToolsService} from '../../core/ui-tools.service';
import {MetaField} from '../../core/definitions/meta-field';
import {BaseModel} from '../../core/definitions/base-model';
import {FieldInputType} from '../../core/definitions/field-input-type.enum';
import {CmsApiService} from "../../core/cms-api.service";
import {MetaOperationFieldService} from "../../core/meta-operation-field.service";

@Component({
    selector: 'app-edit-field-switch',
    templateUrl: './edit-field-switch.component.html',
    styleUrls: ['./edit-field-switch.component.scss'],
    standalone: false
})
export class EditFieldSwitchComponent implements OnChanges {
  // Injections
  private readonly fieldStateSvc: FieldStateService = inject(FieldStateService);
  private readonly uiTools: UiToolsService = inject(UiToolsService);
  private readonly cms = inject(CmsApiService);
  private readonly metaOperationFieldService = inject(MetaOperationFieldService)

  @Input() isLocationOperation: boolean;
  @Input() sectionsContainer: SectionsContainer;
  @Input() displayRequiredIndication: boolean;
  @Input() field: MetaField;
  @Input() fieldDataItem: any;
  @Input() grandParentObject: BaseModel;
  @Input() object: BaseModel;
  @Input() index: number;
  @Input() parentIndex: number;
  @Input() grandparentIndex: number;
  @Output() closeEdit = new EventEmitter<any>();

  myObject: BaseModel;
  computer: boolean;
  FieldInputType = FieldInputType;
  setValueObject: BaseModel;
  operationField: MetaField;

  @HostListener('keyup', ['$event'])
  onEvent(event: KeyboardEvent) {
    event.stopPropagation();
    if (event.key === 'Tab') {
      this.checkIfFieldOutsideTheScreen();
    }
  }

  ngOnChanges() {
    this.setMetaOperationData().then();
    this.computer = this.uiTools.getClientType().isComputer;
    if (!this.object) {
      return;
    }
    this.myObject = this.object;
    if (!this.field.path) {
      return;
    }
    const fieldValue = this.object[this.field.name];
    if (fieldValue !== undefined && typeof fieldValue !== 'object') {
      return;
    }
    if (this.index === undefined && this.field.key.includes('{index1}')) {
      // This will make sure array based prime fields work
      this.index = 0;
    }
    const parentSub = this.fieldStateSvc.getParentSubObject(
      this.sectionsContainer.rootObject, this.field, this.index, this.parentIndex, this.grandparentIndex);
    if (parentSub.subObject) {
      this.myObject = Array.isArray(parentSub.subObject) ? parentSub.subObject[0] : parentSub.subObject;
      if (this.myObject instanceof BaseModel && parentSub.parentObject instanceof  BaseModel &&
        this.myObject.object_type !== parentSub.parentObject.object_type) {
        this.grandParentObject = parentSub.parentObject;
      }
    } else {
      this.myObject = Array.isArray(parentSub.parentObject) ? parentSub.parentObject[0] : parentSub.parentObject;
      this.grandParentObject = this.object;
    }
  }

  checkIfFieldOutsideTheScreen() {
    setTimeout(() => {
      if (this.computer && document.activeElement) {
        const activeElement = document.activeElement.getBoundingClientRect();
        const windowTop = (window.innerHeight - 50) + window.pageYOffset;
        if (activeElement) {
          const positionTop = activeElement.top + 220 + window.pageYOffset;
          if (positionTop > windowTop) {
            this.scrollWindowToField(window.pageYOffset);
          }
        }
      }
    }, 300);
  }

  scrollWindowToField(offset: number) {
    const scrollTo = offset + 250;
    window.scrollTo({top: scrollTo, behavior: 'smooth'});
  }

  onCloseEdit() {
    this.closeEdit.emit();
  }

  private async setMetaOperationData() {
    if (this.field.input_type === FieldInputType.META_OPERATION_FIELD.toString()) {
      this.operationField = null;
      if (this.sectionsContainer.rootObject.object_type === 'MultipleFieldValueOperationModel') {
        this.setValueObject = this.sectionsContainer.rootObject['field_value_operation_items'][this.index];
      } else {
        this.setValueObject = this.sectionsContainer.rootObject;
      }
      this.operationField = await this.cms.getMetaFieldById(this.setValueObject['select_field']);
      await this.metaOperationFieldService.setTheValueObject(
        this.sectionsContainer, this.field, this.operationField, this.setValueObject, this.parentIndex || 0, true);
    }
  }
}
